import { OrFormSubmitResponse } from '@curran-catalog/curran-atomic-library'
import { ServicesToSendType } from '@utils/render'
import Router from 'next/router'
import { responseCodes, responseTypes } from 'types/api-forms'

const allowServices = (service: ServicesToSendType): string => {
  const servicesSelected = Object.keys(service).filter((key) => service[key].enabled)
  return servicesSelected.join(',')
}

export const submitForm = (formValues: FormData, serviceToSendData: ServicesToSendType, isRedirect: boolean) => {
  const services = allowServices(serviceToSendData)
  const formObject: { [key: string]: string } = {}
  formValues.forEach((value, key) => (formObject[key] = value as string))
  return new Promise<OrFormSubmitResponse>((resolve, reject) => {
    const headers = new Headers()
    headers.append('services-allow', services)

    if (services.includes('hubspot')) {
      const { portalId, formId } = serviceToSendData['hubspot'].data
      headers.append('form-id', formId)
      headers.append('portal-id', portalId)
    }

    if (services.includes('mailgun')) {
      const mailgun_data = serviceToSendData['mailgun'].data
      if ('quote' in mailgun_data) {
        headers.append('mailgun-type', 'quote')
      } else {
        headers.append('mailgun-type', 'generic')
      }
    }

    fetch('/api/submit-form', {
      method: 'POST',
      headers,
      body: formValues,
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.code === 200) {
          if (isRedirect) {
            const message = res.message.join(' ')
            localStorage.setItem('form-submitted-message', message)
            Router.push({ pathname: '/form-submitted' })
            return
          }
          resolve({ success: true, code: res.code, title: 'Submitted!', message: res.message })
        }
        resolve({
          success: false,
          code: res.code,
          title: 'Error!',
          message: res.message || res.error.message || responseCodes[responseTypes.GENERIC].message,
        })
      })
      .catch((error) => {
        reject({
          success: false,
          code: error.code || responseCodes[responseTypes.GENERIC].code,
          title: 'Error!',
          message:
            error.statusText ||
            `File size too large. Combined file size cannot exceed 4.5mb. Contact sales@curranonline.com for assistance. ${
              responseCodes[responseTypes.GENERIC].message
            }`,
        })
      })
  })
}
